import React, { useEffect, useState,useRef  } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import Loader from '../../components/Loader';
import Paginator from "../../components/Paginator"; 
import AddQuestion from '../../components/AddQuestion';
import AddSubTypeQuestion from '../../components/AddSubTypeQuestion';
import UploadQuestion from '../../components/UploadQuestion';
import { toast } from 'react-toastify';
import ApiService from '../../services/ApiService';
import Swal from 'sweetalert2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import UploadSubTypeQuestion from '../../components/UploadSubTypeQuestion';

const AddUpdate = () => {
  
  const isFirstRender = useRef(true);

  const { id } = useParams();
  const navigate = useNavigate();
  const [tab, setTab] = useState("info");
  const [subsetId, setSubsetId] = useState(null);
  const [addQuestion, setAddQuestion] = useState(false);
  const [addSubTypeQuestion, setAddSubTypeQuestion] = useState(false);
  const [uploadQuestion, setUploadQuestion] = useState(false);
  const [uploadSubTypeQuestion, setUploadSubTypeQuestion] = useState(false);
  const [subsets, setSubsets] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [edit_question, setEditQuestion] = useState([]);
  const [edit_sub_type_question, setEditSubTypeQuestion] = useState([]);
  const [pagination, setPagination] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
  });
  const [apiData, setApiData] = useState({
      search: "",
      daterange: "",
      page: 0,
      subsetId: 0,
  });



  useEffect(() => {
    if (id) {
      getSingleData();
    }
  }, [id]);

  const getSingleData = async () => {
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: 'GET',
        url: `tests/${id}`, // Replace with your API endpoint
      });
      const data = response.data;
      if (data.status) {
        setFormData(data.data);
        setSubsets(data.data.sections);
        
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoader(false);
    }
  };


  useEffect(() => {
    console.log(isFirstRender.current);
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return; // Skip running `getQuestions` on the first render
    }
    getQuestions();
  }, [apiData]);

  const getQuestions = async () => {
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: 'GET',
        url: `questions`, // Replace with your API endpoint
        data: apiData
      });
      const data = response.data;
      if (data.status) {
        console.log(data,'data.data');
        setQuestions(data.data);
        setPagination(data.pagination);
        setTab('questions');
        
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoader(false);
    }
  };
  const handlePageChange = (event) => {
      setApiData(prev => ({ ...prev, page: event }));
  };
  const clearFilter = () => {
      setApiData({
          search: '',
          daterange: '',
          page: 0
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const saveTest = async (e) => {
    e.preventDefault();
    setIsLoader(true);

    try {
      const data = new FormData();
      Object.keys(formData).forEach((key) => {
        data.append(key, formData[key]);
      });

      const response = await ApiService.request({
        method: 'POST',
        url: `tests/createOrUpdate/${id || ''}`, // Replace with your API endpoint
        data,
      });

      if (response.data.status) {
        toast.success(response.data.message);
        const data=response.data.data;
        navigate('/tests/create/'+data.id);
      } else {
        toast.error(response.data.message);
      }
      setIsLoader(false);
    } catch (error) {
      console.error('Form submission failed:', error);
    } finally {
      setIsLoader(false);
    }
  };

  

  // Subset Functions
  const newSubset = () => {
    const newSubset = {
      title: "",
      description: "",
      instruction_mins: "",
      section_mins: "",
    };
    // Update the subsets array immutably
    setSubsets((prevSubsets) => [...prevSubsets, newSubset]);
    
  };
  const saveSubset = async (e) => {
    e.preventDefault();
    setIsLoader(true);

    try {

      const response = await ApiService.request({
        method: 'POST',
        url: `tests/subsets/${id || ''}`, // Replace with your API endpoint
        data:{'subsets':subsets},
      });

      if (response.data.status) {
        toast.success(response.data.message);
        getSingleData();
      } else {
        toast.error(response.data.message);
      }
      setIsLoader(false);
    } catch (error) {
      console.error('Form submission failed:', error);
    } finally {
      setIsLoader(false);
    }
  };
  const removeSubset = (index) => {
    console.log(index);
    setSubsets((prevSubsets) => prevSubsets.filter((_, i) => i !== index));
  };
  const handleSubsetChange = (index, field, value) => {
    setSubsets((prevSubsets) =>
      prevSubsets.map((subset, i) =>
        i === index ? { ...subset, [field]: value } : subset
      )
    );
  };
  const getSubsetQuestions = (subsetId) => {
    setApiData(prev => ({ ...prev, subsetId: subsetId }));
    getQuestions();
  };


  //Question Functions
  const delData = async (id) => {
    const result = await Swal.fire({
        title: 'Are you sure?',
        text: 'you will not be able to revert it!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonColor: '#9E9B9B',
        cancelButtonText: 'no',
    });

    if (result.isConfirmed) {
        const response = await ApiService.request({
            method: "DELETE",
            url: `questions/${id}`, // Replace with your API endpoint
        });
        const data = response.data;
        if (data.status) {
            getQuestions();
            toast.success(data.message);
        } else {
            toast.error(data.message);
        }
    }
  };

  const updateStatus = async (id) => {
      const result = await Swal.fire({
          title: 'Are you sure?',
          text: "you want to change its status!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#4BC95F',
          confirmButtonText: 'Yes',
          cancelButtonColor: '#9E9B9B',
          cancelButtonText: 'No',
      });

      if (result.isConfirmed) {
          const response = await ApiService.request({
              method: "POST",
              url: `questions/status/${id}`, // Replace with your API endpoint
          });
          const data = response.data;
          if (data.status) {
              getQuestions();
              toast.success(data.message);
          } else {
              toast.error(data.message);
          }
      }
  };
  const closeModal = () => {
    setAddQuestion(false);
    setAddSubTypeQuestion(false);
    setUploadQuestion(false);
    setUploadSubTypeQuestion(false);
    setEditQuestion(null);
    setEditSubTypeQuestion(null);
  };
  const editQuestion = (question) => {
    setEditQuestion(question);
    setAddQuestion(true);
  };
  const editSubTypeQuestion = (question) => {
    console.log(question,'question');
    setEditSubTypeQuestion(question);
    setAddSubTypeQuestion(true);
    setAddQuestion(false);
  };
  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
              {id ? 'Edit' : 'Add New'} Test
            </h1>
            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
              <li className="breadcrumb-item text-muted">
                <Link to="/dashboard" className="text-muted text-hover-primary">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-item text-muted">
                <Link to="/tests" className="text-muted text-hover-primary">Tests</Link>
              </li>
            </ul>
          </div>
        
          {/* Upload */}
          {id && 
            <>
              <button className='btn btn-base btn-sm' style={{marginLeft: 'auto', marginRight: '10px'}}  onClick={()=>setUploadQuestion(true)}>
                <i className='bi bi-upload text-white'></i> Upload Questions
              </button>
              <button className='btn btn-base btn-sm' onClick={()=>setUploadSubTypeQuestion(true)}>
                <i className='bi bi-upload text-white'></i> Upload Sub Type Questions
              </button>
            </>
          }

        </div>
      </div>

      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-xxl">
          <div className="card">
              <nav>
                  <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    <button  className={`nav-link fs-lg-5 ${tab === "info" ? "active" : ""}`}
                        onClick={() => setTab("info")}
                        id="nav-profile-tab"  type="button"  >
                        <i className="bi bi-info-circle-fill"></i> Test Info
                    </button>
                    <button  className={`nav-link fs-lg-5 ${tab === "subset" ? "active" : ""}`}
                        onClick={() => setTab("subset")}
                        id="nav-contact-tab"  type="button"  >
                        <i className="bi bi-stack"></i> Subsets
                    </button>
                    <button  className={`nav-link fs-lg-5 ${tab === "questions" ? "active" : ""}`}
                        onClick={() => setTab("questions")}
                        id="nav-contact-tab"  type="button"  >
                        <i className="bi bi-question-circle-fill"></i> Questions
                    </button>
                  </div>
              </nav>

            <div className="card-body pt-0">
              {tab === "info" && (
                <form onSubmit={saveTest} className="form fv-plugins-bootstrap5 fv-plugins-framework">
                  <div className="row g-9 my-3">
                    <div className="col-md-12 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2"> Title</label>
                      <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter Test Title"
                        required
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-12 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2"> Description</label>

                      <textarea id="description" required  rows={5}
                        placeholder="Write Test Description"
                        name="description" className="form-control form-control-solid"
                        value={formData.description}
                        onChange={handleChange}>
                      </textarea>
                    </div>
                  </div>

              

                  <div className="row g-9 my-3">
                    <div className="text-center">
                      <Link to={`/tests`} className="btn btn-light me-3">Back</Link>
                      <button type="submit" className="btn btn-base" disabled={isLoader}>
                        <span className="indicator-label">{isLoader ? <Loader size="20" color="white" text="Submitting" /> : 'Submit'}</span>
                      </button>
                    </div>
                  </div>
                </form>
              )}
              {tab === "subset" && id && (
                <form onSubmit={saveSubset} className="form fv-plugins-bootstrap5 fv-plugins-framework">
                  <button type="button" onClick={newSubset} className='btn btn-base btn-sm my-3'>New Subset</button>

                  <div className="row">
                    <div className="col-4"> <h6> Name</h6> </div>
                    <div className="col-4"> <h6> Desc</h6> </div>
                    <div className="col-1"> <h6> Instruction Mins</h6> </div>
                    <div className="col-1"> <h6> Section Mins</h6> </div>
                    <div className="col-2"> <h6> Action</h6> </div>
                  </div>
                  {subsets.length > 0 ? subsets.map((subset, index) => (
                    <div className="row mb-3" key={index}>
                      <div className="col-4"> 
                            <input type="text" required className="form-control" value={subset.title} placeholder='Enter Subset Title' onChange={(e) =>
                              handleSubsetChange(index, "title", e.target.value)} />
                      </div>
                      <div className="col-4"> 
                              <textarea required className="form-control" value={subset.description} placeholder='Write Subset Description' onChange={(e) =>
                              handleSubsetChange(index, "description", e.target.value)}></textarea>
                      </div>
                      <div className="col-1">
                            <input type="number" required className="form-control" value={subset.instruction_mins} placeholder='Instruction Mins'  onChange={(e) =>
                              handleSubsetChange(index, "instruction_mins", e.target.value)} />  
                      </div>
                      <div className="col-1">
                            <input type="number" required className="form-control" value={subset.section_mins} placeholder='Section Mins'  onChange={(e) =>
                              handleSubsetChange(index, "section_mins", e.target.value)}/>   
                      </div>
                      <div className="col-2">
                          <button type='button' className='btn btn-danger btn-sm m-1'  onClick={() => removeSubset(index)}> <i className='bi bi-trash'></i> </button> 
                          {subset.id && (
                            <button type='button'  className='btn btn-base btn-sm m-1' onClick={() => getSubsetQuestions(subset.id) }>Questions</button> 
                          )}
                      </div>
                    </div>
                   )):(
                        <h6 className="text-dark text-center mt-2">No data found!</h6>
                  )}


                  <div className="row g-9 my-3">
                    <div className="text-center">
                      <Link to={`/tests`} className="btn btn-light me-3">Back</Link>
                      <button type="submit" className="btn btn-base" disabled={isLoader}>
                        <span className="indicator-label">{isLoader ? <Loader size="20" color="white" text="Submitting" /> : 'Submit'}</span>
                      </button>
                    </div>
                  </div>
                </form>
              )}

              {tab === "questions" && id && (
                <div className="">
                  
                  {apiData.subsetId ? (
                        <>
                          <button
                            type="button"
                            onClick={() => { setEditQuestion(null); 
                              setEditSubTypeQuestion(null);
                              setAddQuestion(true);
                              setAddSubTypeQuestion(false);
                            
                            }}
                            className="btn btn-base btn-sm my-2 ms-2 float-end"
                          >
                            New Question
                          </button>
                          <button
                            type="button"
                            onClick={() => { setEditSubTypeQuestion(null);
                              setEditQuestion(null);
                               setAddSubTypeQuestion(true);
                               setAddQuestion(false);
                            }}
                            className="btn btn-base btn-sm my-2 mr-2 ms-2 float-end"
                          >
                            New sub type question
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            type="button"
                            onClick={() => { alert('Select Subset to add question!'); }}
                            className="btn btn-base btn-sm my-2 mr-2 ms-2 float-end"
                          >
                            New Question
                          </button>
                          <button
                            type="button"
                            onClick={() => { alert('Select Subset to add question!'); }}
                            className="btn btn-base btn-sm my-2 float-end"
                          >
                            New sub type question
                          </button>
                        </>
                      )}

                      <div className="row mt-3">
                        <div className="col-md-4">
                            <div className="d-flex align-Tests-center position-relative my-1">
                                <input type="text" value={apiData.search} onChange={e => setApiData({ ...apiData, search: e.target.value })} className="form-control form-control-solid me-5"
                                  placeholder={("Search Question title..")} />
                            </div>
                        </div>
                        <div className="col-md-4">
                          <select value={apiData.subsetId} onChange={e => setApiData({ ...apiData, subsetId: e.target.value })} className='form-select'>
                            <option value="">Select Subset</option>
                            {subsets.map((subset, index) => (
                             <option value={subset.id}>{subset.title}</option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-3">
                            <DatePicker
                                selectsRange={true}
                                startDate={apiData.daterange[0]}
                                endDate={apiData.daterange[1]}
                                onChange={e => setApiData({ ...apiData, daterange: e })} 
                                isClearable={true}
                                className='form-control form-control-solid'
                                placeholderText={('Select Daterange')}
                            />
                        </div>
                        <div className="col-md-3 mt-2">
                            <button type="button" onClick={clearFilter} className={`btn btn-sm btn-secondary mx-1 ${!apiData.search && !apiData.daterange ? 'd-none' : ''}`}>{("clear")}</button>
                        </div>
                      </div>
                    <div className="table-responsive">
                        <table className="table align-middle table-hover fs-6 gy-5 dataTable no-footer">
                            <thead>
                                <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                    <th>Question</th>
                                    <th>Answer Details</th>
                                    {/* <th>Options</th> */}
                                    <th>Status</th>
                                    <th>Created Date</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody className="fw-semibold text-gray-600 fs-6">
                                {questions.length > 0 ? questions.map((qa, index) => (
                                    <tr key={index}>
                                        <td>{qa.text}</td>
                                        <td>{qa.answer_details}</td>
                                        <td>
                                            <button className="p-0 btn btn-transparent">
                                                <span className={`badge ${qa.status === 1 ? 'badge-light-success' : 'badge-light-danger'}`} onClick={() => updateStatus(qa.id)} >
                                                    {qa.status === 1 ? 'Active' : 'Inactive'}
                                                </span>
                                            </button>
                                        </td>
                                        <td>{qa.created_at}</td>
                                        <td className="mt-2">
                                          {console.log(qa,'qa')}
                                            <button type="button" 
                                             onClick={() => qa.type == 'sub_type' ? editSubTypeQuestion(qa) : editQuestion(qa)}    className="btn btn-sm h-30px btn-light-primary jj">
                                                <i className="bi bi-pencil-fill fs-6"></i>
                                            </button>
                                            <button  onClick={() => delData(qa.id)} className="btn btn-sm h-30px btn-light-primary okk">
                                                <i className="bi bi-trash-fill fs-6"></i>
                                            </button>
                                        </td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="11" className="text-dark text-center mt-2">No data found!</td>
                                    </tr>
                                )}
                            </tbody>
                        </table> 
                        {isLoader && (
                            <Loader text="Loading" size="30" className="d-flex justify-content-center align-items-center"  />
                        )}

                        {pagination.total_pages > 1 && (
                            <Paginator
                                page={pagination.current_page}
                                rows={pagination.per_page}
                                totalRecords={pagination.total_records}
                                onPageChange={handlePageChange}
                            />
                        )}
                    </div>
                    {addQuestion &&
                      <AddQuestion editQuestion={edit_question} updateQuestions={getQuestions} closeModal={closeModal} test_id={id} subset_id={apiData.subsetId} /> 
                    }
                    
                    {console.log(edit_sub_type_question,'edit_sub_type_question')}
                    {addSubTypeQuestion &&
                      <AddSubTypeQuestion 
                          editQuestion={edit_sub_type_question} 
                          updateQuestions={getQuestions} 
                          closeModal={closeModal} 
                          test_id={id} 
                          subset_id={apiData.subsetId} 
                      /> 
                  }

                </div>

              )}

              {!id  && (
                <h4 className='text-center my-5 text-base'>Add Test Info first!</h4>
              )}

              {uploadQuestion &&
                      <UploadQuestion  updateQuestions={getSingleData} closeModal={closeModal} test_id={id} /> 
              }
              {uploadSubTypeQuestion &&
                      <UploadSubTypeQuestion  updateQuestions={getSingleData} closeModal={closeModal} test_id={id} /> 
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUpdate;
